jQuery( function( $ ) {
    "use strict";

    var $modal = $( '[data-vws-quote-modal]' );

    if ( ! $modal.length ) {
        return;
    }

    var $body       = $( 'body' );
    var last_focus  = null;
    var title_field = window.vwsQuoteData && window.vwsQuoteData.titleSelector
        ? window.vwsQuoteData.titleSelector
        : '.vws-quote-product-title';
    var id_field    = window.vwsQuoteData && window.vwsQuoteData.idSelector
        ? window.vwsQuoteData.idSelector
        : '.vws-quote-product-id';

    function setFieldValue( selector, value ) {
        $modal.find( selector ).each( function() {
            var $field = $( this );
            var $input = $field.is( 'input, textarea, select' )
                ? $field
                : $field.find( 'input, textarea, select' ).first();

            if ( ! $input.length ) {
                return;
            }

            $input.val( value ).trigger( 'input' ).trigger( 'change' );
        } );
    }

    function getFocusableElements() {
        return $modal.find( 'a[href], area[href], input:not([type="hidden"]), select, textarea, button, [tabindex]:not([tabindex="-1"])' )
            .filter( ':visible:not(:disabled)' );
    }

    function openModal( $button ) {
        var title = $button.attr( 'data-product-title' ) || '';
        var id    = $button.attr( 'data-product-id' ) || '';

        last_focus = document.activeElement;

        setFieldValue( title_field, title );
        setFieldValue( id_field, id );
        $modal.removeAttr( 'hidden' ).attr( 'aria-hidden', 'false' );
        $body.addClass( 'vws-quote-modal-open' );

        var $focusable = getFocusableElements();

        if ( $focusable.length ) {
            $focusable.first().trigger( 'focus' );
        }
    }

    function closeModal() {
        $modal.attr( 'hidden', true ).attr( 'aria-hidden', 'true' );
        $body.removeClass( 'vws-quote-modal-open' );

        if ( last_focus && typeof last_focus.focus === 'function' ) {
            last_focus.focus();
        }
    }

    function initializeVariationPicker( $picker ) {
        var $selects = $picker.find( 'select[data-attribute_name]' );
        var $button  = $picker.find( '[data-vws-quote]' );
        var $status  = $picker.find( '[data-vws-quote-variation-selection]' );
        var baseTitle = $button.attr( 'data-product-title' ) || '';
        var variations = [];

        try {
            variations = JSON.parse( $picker.attr( 'data-vws-quote-variations' ) || '[]' );
        } catch ( error ) {
            variations = [];
        }

        function updateSelection() {
            var selected_attributes = {};
            var selected_labels     = [];
            var has_selection       = $selects.length > 0;

            $selects.each( function() {
                var $select = $( this );
                var value   = $select.val();

                if ( ! value ) {
                    has_selection = false;
                    return;
                }

                selected_attributes[ $select.attr( 'name' ) ] = value;
                selected_labels.push( $select.find( 'option:selected' ).text() );
            } );

            var selected_variation = null;

            if ( has_selection ) {
                $.each( variations, function( index, variation ) {
                    var matches = Object.keys( selected_attributes ).every( function( attribute_name ) {
                        if ( ! variation.attributes || ! Object.prototype.hasOwnProperty.call( variation.attributes, attribute_name ) ) {
                            return false;
                        }

                        var variation_value = variation.attributes[ attribute_name ];

                        return '' === variation_value || variation_value === selected_attributes[ attribute_name ];
                    } );

                    if ( matches ) {
                        selected_variation = variation;

                        return false;
                    }
                } );
            }

            var is_available = Boolean( selected_variation );
            var selection    = selected_labels.join( ', ' );

            $button.prop( 'disabled', ! is_available ).attr( 'aria-disabled', is_available ? 'false' : 'true' );
            $button.attr( 'data-product-title', is_available ? baseTitle + ' — ' + selection : baseTitle );
            $button.attr( 'data-product-variation-id', is_available ? selected_variation.id : '' );
            $status.text( is_available ? 'Selected: ' + selection : '' );
        }

        $selects.on( 'change.vwsQuoteVariation', updateSelection );
        updateSelection();
    }

    $( '[data-vws-quote-variation-picker]' ).each( function() {
        initializeVariationPicker( $( this ) );
    } );

    $( document ).on( 'click.vwsQuote', '[data-vws-quote]', function() {
        if ( $( this ).is( ':disabled' ) ) {
            return;
        }

        openModal( $( this ) );
    } );

    $modal.on( 'click.vwsQuote', '[data-vws-quote-close]', function() {
        closeModal();
    } );

    $( document ).on( 'keydown.vwsQuote', function( event ) {
        if ( $modal.is( '[hidden]' ) ) {
            return;
        }

        if ( 'Escape' === event.key ) {
            event.preventDefault();
            closeModal();

            return;
        }

        if ( 'Tab' !== event.key ) {
            return;
        }

        var $focusable = getFocusableElements();

        if ( ! $focusable.length ) {
            event.preventDefault();

            return;
        }

        var first = $focusable.get( 0 );
        var last  = $focusable.get( $focusable.length - 1 );

        if ( event.shiftKey && document.activeElement === first ) {
            event.preventDefault();
            last.focus();
        } else if ( ! event.shiftKey && document.activeElement === last ) {
            event.preventDefault();
            first.focus();
        }
    } );
} );



// WEBPACK FOOTER //
// ./resources/assets/scripts/woocommerce-quote.js